export default __webpack_public_path__ + "static/1776-d9f3cf79d0962fd12596208d78fb4deb.gif";